import { TariffParameterBasicInfo } from '@/__generated';
import { apiSdk } from '@/httpClient';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {}
export default function TicketConditionInput({ ...props }: Props) {
  const [data, setData] = React.useState<TariffParameterBasicInfo[]>([]);

  React.useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    apiSdk.TariffParameterService.getTariffParametersByCategory({ isTicketCondition: true }).then(res => {
      setData(res || []);
    });
  };
  return (
    <Select
      maxTagCount="responsive"
      allowClear
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {c.name}
          </Select.Option>
        );
      })}
    </Select>
  );
}
